import { HeroSection } from "./_components/HeroSection";
import { StatsSection } from "./_components/StatsSection";
import { ServicesSection } from "./_components/ServicesSection";
import { LenderPanel } from "./_components/LenderPanel";
import { TestimonialsSection } from "./_components/TestimonialsSection";
import { CTASection } from "@/components/common";

export function HomePage() {
  return (
    <>
      {/* Hero - design-5 style */}
      <HeroSection />

      {/* Lender Panel */}
      <LenderPanel />

      {/* Stats - design-4 style */}
      <StatsSection />

      {/* Services - Tailored Solutions */}
      <ServicesSection />

      {/* Testimonials */}
      <TestimonialsSection />

      {/* CTA */}
      <CTASection
        label="Ready to get started?"
        title="Let's find the right loan for you"
        description="Book a free consultation to discuss your goals and explore your options with our expert team."
        primaryAction={{ label: "Book Consultation", href: "/contact" }}
        secondaryAction={{ label: "Call Us", href: "tel:" }}
      />
    </>
  );
}
